export const config = {
  uxaUrl: 'https://app.contentsquare.com',
  apiUrl: 'https://webapi.contentsquare.com',
  loginUrl: 'https://staging-login.contentsquare.com/',
  proxyUrl: 'https://proxy-staging.contentsquare.com',
  translationUrl: 'https://i18n.contentsquare.com/v1',
  locale: 'en',
  featureFlags: {} as any,
  isProd: true,
  microFrontends: {
    'app-merchandising': 'v1.108.8',
    'app-federation': 'v1.12.95',
  },
};
